import React, { Component } from 'react';
import './LoginStyle.css';
import { AiFillFacebook, AiFillLinkedin } from 'react-icons/ai'
import { FaSquareXTwitter } from "react-icons/fa6";
import { MdEmail } from 'react-icons/md'
import { FaWhatsappSquare } from 'react-icons/fa'

export default class LogoAndLinks extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
        }
    }
    showTOUTbl() {
        this.props.showTOUScreen();
    }
    GetTagLine() {
        if ((_PRODUCTINFO.TagLine || "").length > 0)
            return _PRODUCTINFO.TagLine;
        return <span>Next-Gen ERP Software Solution <br /> for Logistics & Freight Forwarders</span>;
    }
    render() {
    let whatsappUrl = `https://api.whatsapp.com/send?phone=${_PRODUCTINFO.SupportWhatsAppNo}&text=${_PRODUCTINFO.SupportWhatsAppText}`
        return (
            <div>
                <div style={{ position: 'fixed', top: '511px', width: '391px', marginLeft: '16px' }}>
                    <div style={_PRODUCTINFO.SupportWhatsAppNo === '' ? { height: '30px', width: '409px', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', top: '494px' } : { height: '30px', display: 'flex', alignItems: 'center', position: 'fixed', top: '494px', width: '395px' }} >
                        <div className="social msg-invisible"><a href="https://twitter.com/softlinkglobal" tabIndex='-1' target="_blank" className="login-icons" style={{ color: '#188DB2' }}><FaSquareXTwitter  /></a></div>
                        <div className="social"><a href="https://twitter.com/softlinkglobal" tabIndex="14" target="_blank" className="login-icons" style={{ color: '#188DB2' }}><FaSquareXTwitter  /></a></div>
                        <div className="social"><a href="https://www.facebook.com/softlinkglobal/" tabIndex="15" target="_blank" className="login-icons" style={{ color: '#188DB2' }}><AiFillFacebook /></a></div>
                        <div className="social"><a href="https://www.linkedin.com/company/softlink-global-pvt-ltd/" tabIndex="16" target="_blank" className="login-icons" style={{ color: '#188DB2' }}><AiFillLinkedin /></a></div>
                        <div className="social"><a href={"mailto:" + _PRODUCTINFO.SupportEMail} tabIndex='-1' className="login-icons" style={{ color: '#188DB2' }}><MdEmail /></a></div>
                        <div className={_PRODUCTINFO.SupportWhatsAppNo === '' ? "social msg-invisible" : 'social'}><a href={whatsappUrl} tabIndex="16" target="_blank" className="login-icons" style={{ color: '#188DB2' }}><FaWhatsappSquare /></a></div>
                    </div><br />
                    <div className="logo-hr1-p3"><hr className="logo-hr3" /></div>

                    <div>
                        <ul className="social-list-ul">
                            <li className="social-list-li"><span><a href={_PRODUCTINFO.FeatureURL} tabIndex="17" target="_blank" className="logo-text3-a"><span className="logo-text1">Features</span></a></span></li>
                            <li className="social-list-li"><span><a href="https://softlinkglobal.com/contact/" tabIndex="18" target="_blank" className="logo-text3-a"><span className="logo-text1">Contact Us</span></a></span></li>
                            <li className="social-list-li"><span><a href="javascript:void(0)" onClick={() => this.showTOUTbl()} tabIndex="19" className="logo-text3-a"><span className="logo-text1">Terms of Use</span></a></span></li>
                        </ul>
                    </div>
                    <p className="logo-text3-margin" style={{ textAlign: 'center' }}><a href="http://www.softlinkglobal.com" tabIndex="20" target="_blank" className="logo-text3-a"><span className="logo-text3">&#169; Softlink Global Pvt. Ltd.</span></a></p>
                </div>
            </div>


        );

    }
}
